import * as React from 'react';
import * as _ from 'lodash';

import { Tabs, Tab, MenuItem, Button, Icon } from '@blueprintjs/core';

import { Select, ItemRenderer, ItemPredicate } from '@blueprintjs/select';

import './Settings.scss';
import LeaseClauseType from 'src/models/LeaseClauseType';
import { IRootState } from 'src/reducers';
import actions from 'src/actions';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import Form from 'src/components/controls/forms/Form';
import { FormApi } from 'final-form';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import FormTextArea from 'src/components/controls/forms/redesign/FormTextArea';
import FormButton from 'src/components/controls/forms/redesign/FormButton';
import LeaseClause from 'src/models/LeaseClause';
import PropertyUtil from 'src/util/PropertyUtil';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { FormErrors } from 'src/util/FormErrors';
import FormTextbox from 'src/components/controls/forms/redesign/FormTextbox';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import { AnyObject } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import FormText from 'src/components/controls/forms/redesign/FormText';
import OwnershipContactCategory from 'src/models/OwnershipContactCategory';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import ManageDefaultLessee from './ManageDefaultLessee';
import GeneratedDocsSetting from './GeneratedDocsSetting';
// import SettingsProjectBilling from './SettingsProjectBilling';
// import ManageClientInfo from './ManageClientInfo.redesign';
// import ManageClientContact from './ManageClientContact';
// import ManageClientBilling from './ManageClientBilling';
// import ProjectDetails from './ProjectDetails';
// import ProjectSection from './ProjectSection';
// import ManageUnitSettings from './ManageUnitSettings';
// import ProjectSettings from './ProjectSettings';
import ProjectSettings from './ProjectSettings.redesign';
import { ClientSettings } from './ClientSettings';
import AnimateHeight from 'react-animate-height';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import ContractAddendumClause from './LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClause';
import { ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import DocumentTemplate from 'src/models/DocumentTemplate';
import Ownership from 'src/models/tract_detail/Ownership';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import LeaseTokenExample from './TractComponents/LeaseTokenExample';

interface ISettingsPageState {
    workTypes: Array<{ id: number; name: string }>;
    addingNewClause: boolean;
    editClause: boolean;
    selectedClauseIndex: number;
    selectedDeleteClauseId: number;
    showProjectWorkTypes: string | number;
    showClientLeaseClause: string | number;
    showOwnershipContact: string | number;
    showManageLessee: string | number;
    showGeneratedDocs: string | number;
    showDocTemplates: string | number;
    pageUpdated: boolean;
}

interface ISettingsPageStoreProps {
    clauseTypes: Array<LeaseClauseType>;
    contractClauses: Array<ContractAddendumClause>;
    ownershipContactCategories: OwnershipContactCategoryForm;
    committedCategoriesIds: number[];
    attachedOwners: Array<Ownership>;
    documentTemplates: Array<DocumentTemplate>;
    selectedDocumentTemplates: Array<DocumentTemplate>;
    tractType: string;
    states: PagedResultSet<State>;
    leaseClauseError: string;
    leaseClauseErrorCode: string;
}

// const dudleyData = {
//     companyName: 'Dudley-Land Co.',
//     address: {
//         addressLine1: '5925 NW 63rd St',
//         city: 'Oklahoma City',
//         state: 'Oklahoma',
//         zipCode: '73034'
//     },
//     contactPerson: {
//         firstName: 'Chris',
//         lastName: 'Pope',
//         phoneNumber: '405-919-5445'
//     }

// };

// const clientData = {
//     clientName: 'Dudley-Land Co.',
//     address: {
//         addressLine1: '5925 NW 63rd St',
//         city: 'Oklahoma City',
//         state: 'Oklahoma',
//         zipCode: '73034'
//     },
//     contactPerson: {
//         firstName: 'Jason',
//         lastName: 'Snyder',
//         phoneNumber: '405-808-5228'
//     }

// };
interface ISettingsPageDispatchProps {
    getProjectDetails: (clientNumber: number, projectNumber: number) => void;
    getClauseTypes: (clientNumber: number, projectNumber: number) => void;
    getContractClauses: (clientNumber: number, projectNumber: number) => void;
    getOwnershipContactCategoriesForm: (clientNumber: number, projectNumber: number) => void;
    getAttachedOwners: (clientNumber: number, projectNumber: number) => void;
    getStates: (options: ODataOptions) => void;
    getDocumentTemplates: (clientNumber: number, projectNumber: number) => void;
    getDocumentTemplatesForProject: (clientNumber: number, projectNumber: number) => void;
    attachDocumentTemplates: (clientNumber: number, projectNumber: number, documentTemplateIds: Array<number>) => void;
    removeDocumentTemplates: (clientNumber: number, projectNumber: number, removeIds: Array<number>) => void;
    createContractClause: (clientNumber: number, projectNumber: number, clause: ContractAddendumClause) => void;
    clearClauses: () => void;
    saveOwnershipContactCategories: (ownershipContactCategoryForm: OwnershipContactCategoryForm, clientNumber: number, projectNumber: number) => void;
    updateContractClause: (clientNumber: number, projectNumber: number, clause: ContractAddendumClause) => void;
    deleteClause: (clientNumber: number, projectNumber: number, id: number, tractType: string) => void;
    setDialogShowing: (dialogName: string) => void;
    hideDialog: () => void;
    dumpCategories: () => void;
    clearTemplates: () => void;
    clearClauseError: () => void;
}

type ISettingsPageProps = RouteComponentProps<{ clientNumber?: string; projectNumber?: string }> &
    ISettingsPageStoreProps &
    ISettingsPageDispatchProps;

class SettingsPage extends React.Component<ISettingsPageProps, ISettingsPageState> {
    private form: FormApi;
    private clientNumber: number;
    private projectNumber: number;
    private contactCategoriesInUse: number[];
    private dialogCreators: dialogCreators;
    static contextType = DialogContext;

    constructor(props: ISettingsPageProps) {
        super(props);

        this.state = {
            workTypes: new Array<{ id: number; name: string }>(),
            addingNewClause: false,
            editClause: false,
            selectedClauseIndex: undefined,
            selectedDeleteClauseId: undefined,
            showProjectWorkTypes: 'auto',
            showClientLeaseClause: 0,
            showOwnershipContact: 0,
            showManageLessee: 0,
            showGeneratedDocs: 0,
            showDocTemplates: 0,
            pageUpdated: false
        };

        this.renderWorkTypes = this.renderWorkTypes.bind(this);
    }

    public componentDidMount() {
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.projectNumber = parseInt(this.props.match.params.projectNumber, 10);
        this.dialogCreators = this.context;
        // TODO: Find a better way to store these without hard-coding their values.
        this.props.getProjectDetails(this.clientNumber, this.projectNumber);
        this.props.getClauseTypes(this.clientNumber, this.projectNumber);
        this.props.getOwnershipContactCategoriesForm(this.clientNumber, this.projectNumber);
        this.props.getAttachedOwners(this.clientNumber, this.projectNumber);
        this.props.getDocumentTemplates(this.clientNumber, this.projectNumber);
        this.props.getDocumentTemplatesForProject(this.clientNumber, this.projectNumber);
        this.props.getStates(new ODataOptions().addPaging(1, 100));
    }
    
    public componentDidUpdate(prevProps: ISettingsPageProps) {
        if (!_.isEqual(prevProps, this.props)) {
            this.props.getContractClauses(this.clientNumber, this.projectNumber);
            if (this.props.leaseClauseErrorCode === '13') {
                window.alert('Client Approved Lease Clause is in use and cannot be removed.');
                this.props.clearClauseError();
            }
            if (!_.isEqual(this.props.attachedOwners, prevProps.attachedOwners) && !!this.props.attachedOwners) {
                this.contactCategoriesInUse = this.props.attachedOwners.map(ao => ao.ownershipContactCategoryId);
            }
        }
    }

    public componentWillUnmount() {
        this.props.dumpCategories();
        this.props.clearClauses();
        this.props.clearTemplates();
    }

    private removeWorkType(id: number) {
        const types = [...this.state.workTypes];
        _.remove(types, (item: { id: number; name: string }) => {
            return item.id === id;
        });

        this.setState({ workTypes: types });
    }

    private renderWorkTypes() {
        return this.state.workTypes.map((item: { id: number; name: string }) => {
            const onClick = () => this.removeWorkType(item.id);

            return (
                <div key={item.id}>
                    {item.name}
                    <span className="remove-icon" onClick={onClick}>
                        <Icon icon="cross" />
                    </span>
                </div>
            );
        });
    }

    openAddLeaseClausePanel = () => {
        this.setState({ addingNewClause: true });
    };

    closeAddLeaseClausePanel = () => {
        this.setState({ addingNewClause: false, editClause: false });
    };

    displayContractClauses = () => {
        const clauses = PropertyUtil.SafeGet(() => this.props.contractClauses);

        return this.displayExistingClauses(clauses);
    }

    displayExistingClauses = (clauses: ContractAddendumClause[]) => {
        if (clauses) {
            return clauses.map((c: ContractAddendumClause, index: number) => {
                return (
                    <div key={index} className="card">
                        <div className="lh-fifth-width">{c.leaseClauseType}</div>
                        <div className="lh-three-fifths-width">{c.clauseText}</div>
                        <div className="lh-fifth-width right-align mb-1">
                            <FormButton text="Edit" onClick={() => this.editClause(index)} size="small" className="mr-1" />
                            <FormButton text="Delete" onClick={() => this.selectDeleteClause(c.id)} size="small" intent="danger" />
                        </div>
                    </div>
                );
            });
        } else {
            return <div>No clauses for project</div>;
        }
    }

    editClause = (index: number) => {
        this.setState({ editClause: true, selectedClauseIndex: index });
    };

    updateClause = (values: AnyObject) => {
        this.props.updateContractClause(this.clientNumber, this.projectNumber, values as ContractAddendumClause);
        this.setState({ editClause: false });
    };

    deleteClause = () => {
        this.props.deleteClause(this.clientNumber, this.projectNumber, this.state.selectedDeleteClauseId, this.props.tractType);
        this.setState({ selectedDeleteClauseId: undefined });
        this.props.hideDialog();
    };

    selectDeleteClause = (id: number) => {
        this.setState({ selectedDeleteClauseId: id });
        this.props.setDialogShowing(DialogList.CONFIRM_CLAUSE_DELETE);
    };

    submitCategory = (category: OwnershipContactCategoryForm) => {
        this.props.saveOwnershipContactCategories(category, this.clientNumber, this.projectNumber);
    };

    addCategory = () => {
        if (!this.form) {
            return;
        }

        const formValues: AnyObject = this.form.getState().values;

        const newCategory = new OwnershipContactCategory();
        if (formValues.category) {
            newCategory.isCrossProject = false;
            newCategory.name = formValues.category;
        }

        if (
            newCategory.name &&
            newCategory.name.trim().length > 0 &&
            (!formValues.addCategories ||
                !formValues.addCategories.some(
                    (item: OwnershipContactCategory) => item.name.trim().toLowerCase() === newCategory.name.trim().toLowerCase()
                )) &&
            (!formValues.categories ||
                !formValues.categories.some(
                    (item: OwnershipContactCategory) => item.name.trim().toLowerCase() === newCategory.name.trim().toLowerCase()
                ))
        ) {
            this.form.mutators.push('addCategories', {
                id: newCategory.id,
                name: newCategory.name,
                isCrossProject: false,
            });
        }

        this.form.change('category', undefined);
    };

    categoriesGenerator = (formValues: AnyObject, defaultCategories?: number[], currenCategories?: OwnershipContactCategory[]) => {
        let newCategories: OwnershipContactCategoryForm = {
            categories: !!formValues ? formValues?.categories : [],
            addCategories: [],
            deleteCategories: [],
            updateCategories: [],
        };

        if (currenCategories?.length === 0) {
            newCategories.updateCategories = defaultCategories.map((dc) => {
                let category: OwnershipContactCategory = formValues.categories.find((c: OwnershipContactCategory) => c.id === dc);
                category.isCrossProjectChecked = true;
                return category;
            });
        }

        if (currenCategories?.length > 0) {
            let foundCategories: OwnershipContactCategory[] = [];
            let missingCategoriesIds: number[] = [];

            defaultCategories.forEach((dc) => {
                let category: OwnershipContactCategory = currenCategories.find((c: OwnershipContactCategory) => c.id === dc);
                if (category === undefined) {
                    missingCategoriesIds.push(dc);
                } else {
                    foundCategories.push(category);
                }
            });
            newCategories.updateCategories = missingCategoriesIds.map((mci) => {
                let category: OwnershipContactCategory = formValues.categories.find((c: OwnershipContactCategory) => c.id === mci);
                category.isCrossProjectChecked = true;
                return category;
            });
        }
        return newCategories;
    };

    setDefaultCategories = () => {
        const formValues: AnyObject = this.form.getState().values;
        let defaultCategoriesIds: number[] = [6, 7, 8, 12, 58, 59, 60];
        let currentCategories: OwnershipContactCategory[] = formValues.categories.filter(
            (c: OwnershipContactCategory) => c.isCrossProjectChecked === true
        );

        let newCategories = this.categoriesGenerator(formValues, defaultCategoriesIds, currentCategories);
        this.submitCategory(newCategories);
    };

    validateForm = (values: LeaseClause) => {
        const errors: FormErrors<LeaseClause> = {};

        if (values.clauseText === undefined) {
            errors.clauseText = 'Clause Description Required';
        }

        if (values.leaseClauseTypeId === undefined) {
            errors.leaseClauseTypeId = 'Clause Type Required';
        }

        return errors as FormErrors<AnyObject>;
    };

    removeCurrentCategory = (fields: AnyObject, index: number, contactCategory: OwnershipContactCategory) => {
        if (this.contactCategoriesInUse?.indexOf(contactCategory.id) > -1) {
            this.manageContactCategory(contactCategory.id);
        } else {
            if (contactCategory.name && (contactCategory.name as string).trim().length > 0) {
                this.form.mutators.push('deleteCategories', { id: contactCategory.id, name: contactCategory.name });
            }
            fields.remove(index);
        }
    };

    removeAdditionalCategory = (index: number) => {
        this.form.mutators.remove('addCategories', index);
    };

    updateUniversalCategories = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        const values: AnyObject = this.form.getState().values;
        let index: number;
        if (values.updateCategories) {
            index = values.updateCategories.findIndex((x: AnyObject) => x.id === id);
        }
        if (index >= 0) {
            this.form.mutators.remove('updateCategories', index); // could be removing the wrong index....
        }
        this.form.mutators.push('updateCategories', { id: id, isCrossProjectChecked: e.currentTarget.value === 'false' });
    };

    submitClientOwner = (data: AnyObject) => {
        window.alert('Client Owner Updated');
    };

    // TODO: Handle Page update success for whole page, not just the doc template library
    handleDocumentTemplateSuccess = () => {
        this.setState({ pageUpdated: true });
        setTimeout(() => { this.setState({ pageUpdated: false }); }, 2000);

        this.props.clearTemplates();
        this.props.getDocumentTemplates(this.clientNumber, this.projectNumber);
        this.props.getDocumentTemplatesForProject(this.clientNumber, this.projectNumber);
    };

    manageContactCategory = (contactCategoryId: number) => {
        let cOwnerships = this.props.attachedOwners.filter(ao => ao.ownershipContactCategoryId === contactCategoryId);
        this.dialogCreators.owners.manageContactCategories(cOwnerships, () => this.props.getAttachedOwners(this.clientNumber, this.projectNumber));
    };

    public render() {
        const WorkTypes = [
            { id: 1, name: 'Lease Acquisition' },
            { id: 2, name: 'Record Checking' },
            { id: 3, name: 'Seismic Permitting' },
            { id: 4, name: 'ROW - Surface Check' },
            { id: 5, name: 'ROW - Permitting' },
            { id: 6, name: 'Due Diligence - In House' },
            { id: 7, name: 'Due Diligence - Field' },
            { id: 8, name: 'Data Input' },
            { id: 9, name: 'Map Preparation' },
            { id: 10, name: 'Auction Attendance' },
            { id: 11, name: 'Title Curative' },
            { id: 12, name: 'Surface Damages' },
            { id: 13, name: 'Runsheets' },
            { id: 14, name: 'Other' },
            { id: 15, name: 'Lease Processing' },
            { id: 16, name: 'Well Proposals/Pooling' },
            { id: 17, name: 'BOA' },
            { id: 18, name: '1099 Miscellaneous' },
            { id: 19, name: 'Spacing' },
            { id: 20, name: 'Well Acquisitions' },
            { id: 21, name: 'Prospect Management' },
            { id: 22, name: 'Integration' },
            { id: 23, name: 'Interactive Digital Runsheets' },
            { id: 24, name: 'Seismic Record Checking' },
            { id: 25, name: 'Completion' },
            { id: 26, name: 'Abstracting' },
            { id: 27, name: 'Imaging' },
            { id: 28, name: 'ROW Acquisition' },
            { id: 29, name: 'ROW Title Research' },
        ];

        const WorkTypeSelect = Select.ofType<{ id: number; name: string }>();

        const selectClauseTypes = this.props.clauseTypes
            ? this.props.clauseTypes.map((type: LeaseClauseType) => new SelectItem(type.id, type.name))
            : undefined;

        const renderWorkType: ItemRenderer<{ id: number; name: string }> = (item, { handleClick, modifiers, query }) => {
            return <MenuItem active={modifiers.active} key={item.id} text={highlightText(item.name, query)} onClick={handleClick} />;
        };

        const predicate: ItemPredicate<{ id: number; name: string }> = (query, item) => {
            return item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
        };

        const selectItem = (item: { id: number; name: string }) => {
            const types = [...this.state.workTypes];
            if (!_.find(types, item)) {
                types.push(item);
                this.setState({ workTypes: types });
            }
        };

        const createClause = (values: AnyObject) => {
            this.props.createContractClause(this.clientNumber, this.projectNumber, values as ContractAddendumClause);
            this.setState({ addingNewClause: false });
        };

        function escapeRegExpChars(text: string) {
            return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
        }

        function highlightText(text: string, query: string) {
            let lastIndex = 0;
            const words = query
                .split(/\s+/)
                .filter((word) => word.length > 0)
                .map(escapeRegExpChars);
            if (words.length === 0) {
                return [text];
            }
            const regexp = new RegExp(words.join('|'), 'gi');
            const tokens: React.ReactNode[] = [];
            while (true) {
                const match = regexp.exec(text);
                if (!match) {
                    break;
                }
                const length = match[0].length;
                const before = text.slice(lastIndex, regexp.lastIndex - length);
                if (before.length > 0) {
                    tokens.push(before);
                }
                lastIndex = regexp.lastIndex;
                tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
            }
            const rest = text.slice(lastIndex);
            if (rest.length > 0) {
                tokens.push(rest);
            }
            return tokens;
        }

        // const Tab1Panel = (
        //     <>
        //         <h5>Manage Billable Work Types For Project</h5>

        //         <WorkTypeSelect
        //             items={WorkTypes}
        //             itemRenderer={renderWorkType}
        //             itemPredicate={predicate}
        //             onItemSelect={selectItem}
        //             resetOnClose={true}
        //             resetOnSelect={true}
        //             popoverProps={{ minimal: false }}
        //             noResults={<MenuItem disabled={true} text="No results." />}
        //             className="lh-add-padding"
        //         >
        //             <Button text="Add Work Type" rightIcon="double-caret-vertical" />
        //         </WorkTypeSelect>

        //         <div className="worktype-panel">{this.renderWorkTypes()}</div>
        //     </>
        // );

        // const Tab2Panel = (
        //     <>
        //         <h5>Manage Client-Approved Lease Clauses</h5>

        //         {this.state.addingNewClause && !this.state.editClause && (
        //             <>
        //                 <Form onSubmit={createClause} validate={this.validateForm}>
        //                     <div style={{ marginBottom: '2rem', fontWeight: 'bold' }}>Add New Clause</div>
        //                     <FormSelect isRequired={true} name="leaseClauseTypeId" items={selectClauseTypes} label="Clause Type" />
        //                     <FormTextArea isRequired={true} name="clauseText" label="Clause" height="15rem" />

        //                     <span style={{ marginRight: '1rem' }}>
        //                         <FormButton type="submit" intent="primary" text="Submit" />
        //                     </span>
        //                     <FormButton onClick={this.closeAddLeaseClausePanel} text="Cancel" />
        //                 </Form>
        //             </>
        //         )}
        //         {this.state.editClause && (
        //             <>
        //                 <Form
        //                     onSubmit={this.updateClause}
        //                     initialValues={this.props.clauses[this.state.selectedClauseIndex]}
        //                     validate={this.validateForm}
        //                 >
        //                     <div style={{ marginBottom: '2rem', fontWeight: 'bold' }}>Edit Clause</div>
        //                     <FormSelect isRequired={true} name="leaseClauseTypeId" items={selectClauseTypes} label="Clause Type" />
        //                     <FormTextArea isRequired={true} name="clauseText" label="Clause" height="15rem" />

        //                     <span style={{ marginRight: '1rem' }}>
        //                         <FormButton type="submit" intent="primary" text="Submit" />
        //                     </span>
        //                     <FormButton onClick={this.closeAddLeaseClausePanel} text="Cancel" />
        //                 </Form>
        //             </>
        //         )}
        //         {!this.state.addingNewClause && !this.state.editClause && (
        //             <>
        //                 <div className="card-list">
        //                     <div className="card">
        //                         <div className="label lh-fifth-width">Type</div>
        //                         <div className="label lh-three-fifths-width">Description</div>
        //                         <div className="label lh-fifth-width right-align" />
        //                     </div>
        //                     {this.displayExistingClauses()}
        //                 </div>

        //                 <div>
        //                     <FormButton text="Add New Approved Clause" intent="primary" onClick={this.openAddLeaseClausePanel} />
        //                 </div>
        //             </>
        //         )}
        //     </>
        // );

        // const Tab3Panel = (
        //     <>
        //         {this.props.ownershipContactCategories && (
        //             <>
        //                 <h2>Ownership Contact Category Management</h2>

        //                 <div style={{ display: 'flex' }}>
        //                     <div style={{ width: '50%' }}>
        //                         <Form
        //                             onSubmit={this.submitCategory}
        //                             onFormCreated={(form) => (this.form = form)}
        //                             hasFieldArray={true}
        //                             initialValues={this.props.ownershipContactCategories}
        //                         >
        //                             <div style={{ fontWeight: 'bold', margin: '3rem 0rem 1rem 0rem' }}>
        //                                 <FormText name="projectCategories" label="Project categories" />
        //                             </div>
        //                             <FormTextbox name="category" label="Category" />
        //                             <div style={{ marginBottom: '1rem' }}>
        //                                 <FormButton size="medium" text="ADD TO PROJECT" onClick={() => this.addCategory()} />
        //                             </div>
        //                             <div>
        //                                 <FieldArray name="categories">
        //                                     {({ fields }) => {
        //                                         return fields.map((name, index) => (
        //                                             <Field key={index} name={`${name}`}>
        //                                                 {({ input }) => (
        //                                                     <>
        //                                                         {!input.value.isCrossProject && (
        //                                                             <span
        //                                                                 style={{
        //                                                                     padding: '.6rem',
        //                                                                     border: '1px solid #ccc',
        //                                                                     background: 'white',
        //                                                                     marginRight: '8px',
        //                                                                     display: 'inline-block',
        //                                                                 }}
        //                                                             >
        //                                                                 {input.value.name}
        //                                                                 <span
        //                                                                     onClick={() => this.removeCurrentCategory(fields, index, input.value)}
        //                                                                     style={{ cursor: 'pointer' }}
        //                                                                 >
        //                                                                     ❌
        //                                                                 </span>
        //                                                             </span>
        //                                                         )}
        //                                                     </>
        //                                                 )}
        //                                             </Field>
        //                                         ));
        //                                     }}
        //                                 </FieldArray>
        //                             </div>
        //                             <div>
        //                                 <FieldArray name="addCategories">
        //                                     {({ fields }) => {
        //                                         return fields.map((name, index) => (
        //                                             <Field key={index} name={`${name}`}>
        //                                                 {({ input }) => (
        //                                                     <span
        //                                                         style={{
        //                                                             padding: '.6rem',
        //                                                             border: '1px solid #ccc',
        //                                                             background: 'white',
        //                                                             marginRight: '8px',
        //                                                             display: 'inline-block',
        //                                                         }}
        //                                                     >
        //                                                         {input.value.name}
        //                                                         <span
        //                                                             onClick={() => this.removeAdditionalCategory(index)}
        //                                                             style={{ cursor: 'pointer' }}
        //                                                         >
        //                                                             ❌
        //                                                         </span>
        //                                                     </span>
        //                                                 )}
        //                                             </Field>
        //                                         ));
        //                                     }}
        //                                 </FieldArray>
        //                             </div>
        //                             <div style={{ fontWeight: 'bold', margin: '3rem 0rem 1rem 0rem' }}>
        //                                 <FormText name="universalCategories" label="Universal categories" />
        //                             </div>
        //                             <div>
        //                                 <FieldArray name="categories">
        //                                     {({ fields }) => {
        //                                         return fields.map((name, index) => (
        //                                             <Field key={index} name={`${name}`}>
        //                                                 {({ input }) => (
        //                                                     <>
        //                                                         {input.value.isCrossProject && (
        //                                                             <FormCheckbox
        //                                                                 name={`${name}.isCrossProjectChecked`}
        //                                                                 label={input.value.name}
        //                                                                 key={input.value.id}
        //                                                                 onChange={(e) => this.updateUniversalCategories(e, input.value.id)}
        //                                                             />
        //                                                         )}
        //                                                     </>
        //                                                 )}
        //                                             </Field>
        //                                         ));
        //                                     }}
        //                                 </FieldArray>
        //                             </div>

        //                             <div style={{ margin: '3rem 0 3rem 0' }}>
        //                                 <FormButton text="SAVE" intent="primary" type="submit" />
        //                             </div>
        //                         </Form>
        //                     </div>
        //                 </div>
        //             </>
        //         )}
        //     </>
        // );

        // const Tab4Panel = (
        //     <>
        //         <div>
        //             {/* <Form
        //                 onSubmit={this.submitClientOwner}
        //                 initialValues={clientData}
        //             >
        //                 <FormTextbox name="clientName" label="Client Name" />
        //                 <h4>Address:</h4>
        //                 <FormTextbox  name="address.addressLine1" label="Address Line 1" />
        //                 <FormTextbox name="address.addressLine2" label="Address Line 2" />
        //                 <FormTextbox className="lh-third-width" name="address.city" label="City" />
        //                 <FormTextbox className="lh-third-width" name="address.state" label="State" />
        //                 <FormTextbox className="lh-third-width" name="address.zipCode" label="Zip Code" />
        //                 <h4>Contact Info:</h4>
        //                 <FormTextbox className="lh-third-width" name="contactPerson.firstName" label="First Name" />
        //                 <FormTextbox className="lh-third-width" name="contactPerson.middleName" label="Middle Name" />
        //                 <FormTextbox className="lh-third-width" name="contactPerson.lastName" label="Last Name" />
        //                 <FormTextbox name="contactPerson.phoneNumber" label="Phone Number" />
        //                 <FormButton text="Update Client Info" type="submit" />
        //             </Form> */}

        //             <ManageDefaultLessee />
        //         </div>
        //     </>
        // );

        // const Tab5Panel = (
        //     <>
        //         <GeneratedDocsSetting />
        //     </>
        // );

        const Tab6Panel = (
            <>
                <section style={{ textAlign: 'center' }}>
                    <RHFLegend title="Additional Settings" />
                </section>
                <section style={{ margin: '2rem auto' }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                            this.setState(this.state.showProjectWorkTypes === 'auto' ? { showProjectWorkTypes: 0 } : { showProjectWorkTypes: 'auto' })
                        }
                    >
                        <RHFLegend title="Manage Billable Work Types For Project" />
                    </div>
                    <AnimateHeight
                        duration={500}
                        height={this.state.showProjectWorkTypes}
                        children={
                            <>
                                <h5>Manage Billable Work Types For Project</h5>

                                <WorkTypeSelect
                                    items={WorkTypes}
                                    itemRenderer={renderWorkType}
                                    itemPredicate={predicate}
                                    onItemSelect={selectItem}
                                    resetOnClose={true}
                                    resetOnSelect={true}
                                    popoverProps={{ minimal: false }}
                                    noResults={<MenuItem disabled={true} text="No results." />}
                                    className="lh-add-padding"
                                >
                                    <Button text="Add Work Type" rightIcon="double-caret-vertical" />
                                </WorkTypeSelect>

                                <div className="worktype-panel">{this.renderWorkTypes()}</div>
                            </>
                        }
                    />
                </section>
                <section>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                            this.setState(this.state.showClientLeaseClause === 0 ? { showClientLeaseClause: 'auto' } : { showClientLeaseClause: 0 })
                        }
                    >
                        <RHFLegend title="Manage Client-Approved Lease Clause" />
                    </div>
                    <AnimateHeight
                        duration={500}
                        height={this.state.showClientLeaseClause}
                        children={
                            <>
                                <h5>Manage Client-Approved Lease Clauses</h5>

                                {this.state.addingNewClause && !this.state.editClause && (
                                    <>
                                        <Form onSubmit={createClause} validate={this.validateForm}>
                                            <div style={{ marginBottom: '2rem', fontWeight: 'bold' }}>Add New Clause</div>
                                            <FormSelect isRequired={true} name="leaseClauseTypeId" items={selectClauseTypes} label="Clause Type" />
                                            <FormTextArea isRequired={true} name="clauseText" label="Clause" height="15rem" />

                                            <span style={{ marginRight: '1rem' }}>
                                                <FormButton type="submit" intent="primary" text="Submit" />
                                            </span>
                                            <FormButton onClick={this.closeAddLeaseClausePanel} text="Cancel" />
                                        </Form>
                                    </>
                                )}
                                {this.state.editClause && (
                                    <>
                                        <Form
                                            onSubmit={this.updateClause}
                                            initialValues={this.props.contractClauses[this.state.selectedClauseIndex]}
                                            validate={this.validateForm}
                                        >
                                            <div style={{ marginBottom: '2rem', fontWeight: 'bold' }}>Edit Clause</div>
                                            <FormSelect isRequired={true} name="leaseClauseTypeId" items={selectClauseTypes} label="Clause Type" />
                                            <FormTextArea isRequired={true} name="clauseText" label="Clause" height="15rem" />

                                            <span style={{ marginRight: '1rem' }}>
                                                <FormButton type="submit" intent="primary" text="Submit" />
                                            </span>
                                            <FormButton onClick={this.closeAddLeaseClausePanel} text="Cancel" />
                                        </Form>
                                    </>
                                )}
                                {!this.state.addingNewClause && !this.state.editClause && (
                                    <>
                                        <div className="card-list">
                                            <div className="card">
                                                <div className="label lh-fifth-width">Type</div>
                                                <div className="label lh-three-fifths-width">Description</div>
                                                <div className="label lh-fifth-width right-align" />
                                            </div>
                                            {this.displayContractClauses()}
                                        </div>

                                        <div>
                                            <FormButton text="Add New Approved Clause" intent="primary" onClick={this.openAddLeaseClausePanel} />
                                        </div>
                                    </>
                                )}
                            </>
                        }
                    />
                </section>
                <section style={{ margin: '2rem auto' }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                            this.setState(this.state.showOwnershipContact === 0 ? { showOwnershipContact: 'auto' } : { showOwnershipContact: 0 })
                        }
                    >
                        <RHFLegend title="Ownership Contact Category Management" />
                    </div>
                    <AnimateHeight
                        duration={500}
                        height={this.state.showOwnershipContact}
                        children={
                            <>
                                {this.props.ownershipContactCategories && (
                                    <>
                                        <h2>Ownership Contact Category Management</h2>

                                        <div style={{ display: 'flex' }}>
                                            <div style={{ width: '50%' }}>
                                                <Form
                                                    onSubmit={this.submitCategory}
                                                    onFormCreated={(form) => (this.form = form)}
                                                    hasFieldArray={true}
                                                    initialValues={this.props.ownershipContactCategories}
                                                >
                                                    <div style={{ fontWeight: 'bold', margin: '3rem 0rem 1rem 0rem' }}>
                                                        <FormText name="projectCategories" label="Project categories" />
                                                    </div>
                                                    <FormTextbox name="category" label="Category" />
                                                    <div style={{ marginBottom: '2rem' }}>
                                                        <div style={{ display: 'flex', gap: '1rem' }}>
                                                            <FormButton size="medium" text="ADD TO PROJECT" onClick={() => this.addCategory()} />
                                                            <FormButton
                                                                size="medium"
                                                                text="SET DEFAULT CATEGORIES"
                                                                onClick={() => this.setDefaultCategories()}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <FieldArray name="categories">
                                                            {({ fields }) => {
                                                                return fields.map((name, index) => (
                                                                    <Field key={index} name={`${name}`}>
                                                                        {({ input }) => (
                                                                            <>
                                                                                {!input.value.isCrossProject && (
                                                                                    <span
                                                                                        style={{
                                                                                            padding: '.6rem',
                                                                                            border: '1px solid #ccc',
                                                                                            background: 'white',
                                                                                            marginRight: '8px',
                                                                                            display: 'inline-block',
                                                                                        }}
                                                                                    >
                                                                                        {input.value.name}
                                                                                        <span
                                                                                            onClick={() =>
                                                                                                this.removeCurrentCategory(fields, index, input.value)
                                                                                            }
                                                                                            style={{ cursor: 'pointer' }}
                                                                                        >
                                                                                            ❌
                                                                                        </span>
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                ));
                                                            }}
                                                        </FieldArray>
                                                    </div>
                                                    <div>
                                                        <FieldArray name="addCategories">
                                                            {({ fields }) => {
                                                                return fields.map((name, index) => (
                                                                    <Field key={index} name={`${name}`}>
                                                                        {({ input }) => (
                                                                            <span
                                                                                style={{
                                                                                    padding: '.6rem',
                                                                                    border: '1px solid #ccc',
                                                                                    background: 'white',
                                                                                    marginRight: '8px',
                                                                                    display: 'inline-block',
                                                                                }}
                                                                            >
                                                                                {input.value.name}
                                                                                <span
                                                                                    onClick={() => this.removeAdditionalCategory(index)}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                >
                                                                                    ❌
                                                                                </span>
                                                                            </span>
                                                                        )}
                                                                    </Field>
                                                                ));
                                                            }}
                                                        </FieldArray>
                                                    </div>
                                                    <div style={{ fontWeight: 'bold', margin: '3rem 0rem 1rem 0rem' }}>
                                                        <FormText name="universalCategories" label="Universal categories" />
                                                    </div>
                                                    <div>
                                                        <FieldArray name="categories">
                                                            {({ fields }) => {
                                                                return fields.map((name, index) => (
                                                                    <Field key={index} name={`${name}`}>
                                                                        {({ input }) => {
                                                                            let hasCommitted = this.props.committedCategoriesIds?.indexOf(input.value.id) > -1;
                                                                            let isInUse = this.contactCategoriesInUse?.indexOf(input.value.id) > -1;
                                                                            return (
                                                                                <>
                                                                                    {input.value.isCrossProject && (
                                                                                        <div className="form-row">
                                                                                            <FormCheckbox
                                                                                                name={`${name}.isCrossProjectChecked`}
                                                                                                label={input.value.name 
                                                                                                    + (this.props.committedCategoriesIds?.indexOf(input.value.id) > -1 ? ' (Contract Generated)' : '')}
                                                                                                key={input.value.id}
                                                                                                onChange={(e) =>
                                                                                                    this.updateUniversalCategories(e, input.value.id)
                                                                                                }
                                                                                                isDisabled={hasCommitted || isInUse}
                                                                                                className={(hasCommitted || isInUse) ? 'disabled' : ''}
                                                                                            />
                                                                                            {(isInUse && !hasCommitted) && (
                                                                                                <FormButton 
                                                                                                    text="Manage" 
                                                                                                    intent="secondary" 
                                                                                                    onClick={() => this.manageContactCategory(input.value.id)}
                                                                                                    style={{ margin: '1rem' }}
                                                                                                />
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                ));
                                                            }}
                                                        </FieldArray>
                                                    </div>

                                                    <div style={{ margin: '3rem 0 3rem 0' }}>
                                                        <FormButton text="SAVE" intent="primary" type="submit" />
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        }
                    />
                </section>
                <section>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.setState(this.state.showManageLessee === 0 ? { showManageLessee: 'auto' } : { showManageLessee: 0 })}
                    >
                        <RHFLegend title="Manage Default Lessee" />
                    </div>
                    <AnimateHeight duration={500} height={this.state.showManageLessee} children={<ManageDefaultLessee states={this.props.states} />} />
                </section>
                <section style={{ margin: '2rem auto' }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.setState(this.state.showGeneratedDocs === 0 ? { showGeneratedDocs: 'auto' } : { showGeneratedDocs: 0 })}
                    >
                        <RHFLegend title="Project Generated Documents" />
                    </div>
                    <AnimateHeight 
                        duration={500} 
                        height={this.state.showGeneratedDocs} 
                        children={
                            <GeneratedDocsSetting
                                documentTemplates={this.props.documentTemplates}
                                selectedTemplateIds={this.props.selectedDocumentTemplates?.map(dt => dt.id)}
                                handleSuccessfulSubmit={this.handleDocumentTemplateSuccess}
                            />
                        } 
                    />
                </section>
                <section style={{ margin: '2rem auto' }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.setState(this.state.showDocTemplates === 0 ? { showDocTemplates: 'auto' } : { showDocTemplates: 0 })}
                    >
                        <RHFLegend title="Generated Document Template Tokens" />
                    </div>
                    <AnimateHeight 
                        duration={500} 
                        height={this.state.showDocTemplates} 
                        children={<LeaseTokenExample />} 
                    />
                </section>
            </>
        );

        // const Tab6Panel = (
        //     <>
        //         <SettingsProjectBilling />
        //     </>
        // );

        // const Tab7Panel = (
        //     <>
        //         <ManageClientInfo showDialog={this.props.setDialogShowing} hideDialog={this.props.hideDialog} />
        //     </>
        // );

        // const Tab8Panel = (
        //     <>
        //         <ManageClientContact />
        //     </>
        // );

        const Tab9Panel = (
            <>
                <ClientSettings showDialog={this.props.setDialogShowing} hideDialog={this.props.hideDialog} states={this.props.states} />
            </>
        );

        const Tab10Panel = (
            <>
                <ProjectSettings showDialog={this.props.setDialogShowing} hideDialog={this.props.hideDialog} />
            </>
        );

        // const Tab13Panel = (

        // );

        return (
            <div style={{ margin: '1em' }}>
                {this.state.pageUpdated && (
                    <>
                        <div
                            id="dirtyFlag"
                            style={{
                                position: 'fixed',
                                top: '4.7rem',
                                left: '0',
                                width: '100%',
                                color: 'white',
                                backgroundColor: 'rgba(0,150,0,.5)',
                                zIndex: 9000,
                                padding: '1rem 0',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <div>Page Options updated successfully!</div>
                        </div>
                    </>
                )}
                <Tabs animate={true} id="TabsExample" key={'vertical'} vertical={true} className="lh-full-width">
                    <Tab id="pset" title="Project Settings" panel={Tab10Panel} />
                    {/* <Tab id="rx" title="Project Work Types" panel={Tab1Panel} />
                    <Tab id="ng" title="Client Approved Lease Clauses" panel={Tab2Panel} />
                    <Tab id="occ" title="Ownership Contact Categories" panel={Tab3Panel} />
                    <Tab id="mco" title="Manage Default Lessee" panel={Tab4Panel} />
                    <Tab id="mdc" title="Manage Document Checklist" panel={Tab5Panel} /> */}
                    <Tab id="aps" title="Additional Project Settings" panel={Tab6Panel} />
                    {/* <Tab id="pb" title="Project Billing" panel={Tab6Panel} /> */}
                    {/* <Tab id="mci" title="Manage Client Information" panel={Tab7Panel} />
                    <Tab id="mcc" title="Manage Client Contact" panel={Tab8Panel} /> */}
                    <Tab id="cs" title="Client Settings" panel={Tab9Panel} />
                    {/* <Tab id="pset" title="Project Settings" panel={Tab13Panel} /> */}
                </Tabs>

                <Dialog dialogName={DialogList.CONFIRM_CLAUSE_DELETE} title="Confirm Delete" onCloseDialog={this.props.hideDialog}>
                    <div>Are you sure that you want to permanently delete the selected clause?</div>
                    <div className="mt-2">
                        <FormButton text="OK" onClick={this.deleteClause} intent="primary" className="mr-1" />
                        <FormButton text="Cancel" onClick={this.props.hideDialog} />
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state: IRootState): ISettingsPageStoreProps => {
    return {
        clauseTypes: state.project.leaseClauseTypes,
        contractClauses: state.leaseClause.contractClauses,
        leaseClauseError: state.leaseClause.error,
        leaseClauseErrorCode: state.leaseClause.errorCode,
        ownershipContactCategories: state.ownershipContactCategories.categories,
        committedCategoriesIds: state.ownershipContactCategories.committedCategoriesIds,
        attachedOwners: state.ownershipContactCategories.attachedOwners,
        documentTemplates: state.documentTemplates.documentTemplates,
        selectedDocumentTemplates: state.documentTemplates.selectedTemplates,
        tractType: state.project.currentProject?.tractTypeName,
        states: state.state.states
    };
};

const mapDispatchToProps: ISettingsPageDispatchProps = {
    dumpCategories: () => actions.ownershipContactCategories.dumpCategories(),
    clearTemplates: () => actions.documentTemplates.clearTemplates(),
    getProjectDetails: (clientNumber: number, projectNumber: number) => actions.project.getProject(clientNumber, projectNumber),
    getClauseTypes: (clientNumber: number, projectNumber: number) => actions.project.getLeaseClauseTypes(clientNumber, projectNumber),
    getContractClauses: (clientNumber: number, projectNumber: number) => actions.clause.getContractClauses(clientNumber, projectNumber),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
    getOwnershipContactCategoriesForm: (clientNumber: number, projectNumber: number) =>
        actions.ownershipContactCategories.getOwnershipContactCategoriesForm(clientNumber, projectNumber),
    getAttachedOwners: (clientNumber: number, projectNumber: number) =>
        actions.ownershipContactCategories.getAttachedOwners(clientNumber, projectNumber),
    getDocumentTemplates: (clientNumber: number, projectNumber: number) => 
        actions.documentTemplates.getDocumentTemplates(clientNumber, projectNumber),
    getDocumentTemplatesForProject: (clientNumber: number, projectNumber: number) => 
        actions.documentTemplates.getDocumentTemplatesForProject(clientNumber, projectNumber),
    attachDocumentTemplates: (clientNumber: number, projectNumber: number, documentTemplateIds: Array<number>) => 
        actions.documentTemplates.attachDocumentTemplates(clientNumber, projectNumber, documentTemplateIds),
    removeDocumentTemplates: (clientNumber: number, projectNumber: number, removeIds: Array<number>) => actions.documentTemplates.removeFromProject(clientNumber, projectNumber, removeIds),
    createContractClause: (clientNumber: number, projectNumber: number, clause: ContractAddendumClause) =>
        actions.clause.createContractClause(clientNumber, projectNumber, clause),
    clearClauses: () => actions.clause.clearClauses(),
    saveOwnershipContactCategories: (ownershipContactCategoryForm: OwnershipContactCategoryForm, clientNumber: number, projectNumber: number) =>
        actions.ownershipContactCategories.saveOwnershipContactCategories(ownershipContactCategoryForm, clientNumber, projectNumber),
    updateContractClause: (clientNumber: number, projectNumber: number, clause: ContractAddendumClause) =>
        actions.clause.updateContractClause(clientNumber, projectNumber, clause),
    deleteClause: (clientNumber: number, projectNumber: number, id: number, tractType: string) => actions.clause.deleteLeaseClause(clientNumber, projectNumber, id, tractType),
    setDialogShowing: (dialogName: string) => actions.layout.showDialog(dialogName),
    hideDialog: () => actions.layout.hideDialog(),
    clearClauseError: () => actions.clause.clearError()
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/project/sections/Settings.tsx